import script from "./reviewSuccessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./reviewSuccessModal.vue?vue&type=script&lang=ts&setup=true"

import "./reviewSuccessModal.vue?vue&type=style&index=0&id=bf7ec9c6&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf7ec9c6"]])

export default __exports__